module.exports = __webpack_public_path__ + "images/skewness2-04-desktop.png";